<div class="relative flex min-w-0 max-w-full items-center overflow-visible rounded-full border border-[#e0dce8] bg-white px-3.5 py-1.5 shadow-sm">
  <input
    [id]="inputId"
    type="text"
    readonly
    class="mobile-task-edit-datepicker-input min-h-0 min-w-0 flex-1 cursor-pointer border-0 bg-transparent py-0 pr-10 text-sm leading-snug text-[#1a1a1a] outline-none ring-0 placeholder:text-[#9ca3af] focus:ring-0"
    tabindex="0"
    [value]="displayValue()"
    [placeholder]="placeholder"
    (click)="openSheet()"
    (keydown.enter)="openSheet()"
    (keydown.space)="$event.preventDefault(); openSheet()"
    [attr.aria-label]="ariaLabel"
    [disabled]="disabled"
  />
  <button
    type="button"
    class="absolute right-2 top-1/2 z-10 inline-flex h-8 w-8 shrink-0 -translate-y-1/2 items-center justify-center rounded-full text-[#171717] transition-colors hover:bg-[#faf7fc] active:bg-[#f5f0fa] disabled:opacity-45"
    (click)="openSheet(); $event.stopPropagation()"
    [disabled]="disabled"
    [attr.aria-label]="clockHintKey.trim() !== '' ? (clockHintKey | translate) : ariaLabel"
  >
    <span class="material-icons text-[20px] leading-none text-[#171717]" aria-hidden="true">schedule</span>
  </button>
</div>

@if (sheetOpen()) {
  <div
    class="mobile-time-wheel-backdrop"
    role="presentation"
    (click)="onBackdrop()"
  ></div>
  <div
    class="mobile-time-wheel-panel"
    role="dialog"
    [attr.aria-modal]="true"
    [attr.aria-label]="ariaLabel"
    tabindex="-1"
  >
    <div class="mobile-time-wheel-wheels">
      <div
        #hourScroll
        class="mobile-time-wheel-viewport"
        (scroll)="onHourScroll()"
        (touchend)="onHourScrollEnd()"
      >
        <div class="mobile-time-wheel-track">
          @for (hourValue of hours; track hourValue) {
            <div class="mobile-time-wheel-item" [class.mobile-time-wheel-item--sel]="draftHour() === hourValue">
              {{ mobileTimeWheelPad2(hourValue) }}
            </div>
          }
        </div>
      </div>
      <div
        #minuteScroll
        class="mobile-time-wheel-viewport"
        (scroll)="onMinuteScroll()"
        (touchend)="onMinuteScrollEnd()"
      >
        <div class="mobile-time-wheel-track">
          @for (minuteValue of minuteOpts; track minuteValue) {
            <div class="mobile-time-wheel-item" [class.mobile-time-wheel-item--sel]="draftMinute() === minuteValue">
              {{ mobileTimeWheelPad2(minuteValue) }}
            </div>
          }
        </div>
      </div>
    </div>
    <div class="mobile-time-wheel-footer">
      <button type="button" class="mobile-time-wheel-ok" (click)="confirmSheet()">
        {{ confirmKey | translate }}
      </button>
    </div>
  </div>
}
